import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import VirtualAccount from "../../components/Payment/PaymentMethod/VirtualAccount/VirtualAccount";
import { PaymentRouteParams } from "../../constants/types";

enum PaymentType {
    VA = "va",
    WALLET = "wallet",
    TRANSFER = "transfer",
}

const PaymentVAPage = () => {
    let { type } = useParams<PaymentRouteParams>();
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        console.log("mounted");
        setIsMounted(true);
    }, []);

    if (type === PaymentType.VA) {
        return <VirtualAccount isMounted={isMounted} />;
    }

    return null;
};

export default PaymentVAPage;
